<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        btitle="Router Static Config"
        style="height: 410px"
      >
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllMap"
                />
                <label for="idSelectAllMap"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in routerTable"
              :key="index"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectMap' + index"
                  />
                  <label :for="'idRowSelectMap' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.routerPort }}</div>
              </td>
              <td>
                <div>{{ row.routerVlan }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Router Static Edit'"
            @close="isShowAddTable = false"
            style="min-height: 410px"
          >
            <form class="form-horizontal" role="form">
             <div class="form-group">
                  <label class="col-sm-3 control-label" for="dstPort"
                    >Router Port</label
                  >
                  <div class="col-sm-5" id="dstPort">
                    <select
                      class="form-control"
                      v-model="routerForm.routerPort"
                    >
                      <option value="">None</option>
                      <option
                        v-for="n in devicePort.gePortNum"
                        :key="n"
                        :value="'e1/' + n"
                      >
                        e1/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.xgePortNum"
                        :key="n"
                        :value="'e2/' + n"
                      >
                        e2/{{ n }}
                      </option>
                      <option
                      v-for="opt in lacpPortTable.maxchannel"
                      :key="opt"
                      :value="'ch-'+ (opt - 1)"
                    >
                      {{
                        "ch- " +
                        (opt-1)
                      }}
                    </option>
                    </select>
                  </div>
                </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="routerVlan">Router VLAN</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                  <input
                    type="text"
                    class="form-control"
                    id="routerVlan"
                    v-model="routerForm.routerVlan"
                    placeholder="INTEGER<1-4094>"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"

export default {
  name: "igmpRouterStatic",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId", "mapMode"],

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      iBox: {},
      isSelectAll: false,
      select: [],
      devicePort: "",
      routerForm: {
          routerPort:"",
          routerVlan:"",
      },

      routerTable: [],
      lacpPortTable:"",
    }
  },

  created() {
    this.loadRouterStaticInfo()
    this.loadDevicePort()
    this.loadLacpPort()
  },

  methods: {
    loadRouterStaticInfo() {
      get("igmpRouterStatic")
        .then((res) => {
          this.routerTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadLacpPort() {
      get("lacpport")
        .then((res) => {
          this.lacpPortTable = res.data
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

     /*获取设备端口信息*/
    loadDevicePort() {
      get("devicePortInfo")
        .then((res) => (this.devicePort = res.data))
        .catch((err) => {})
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
          routerPort:"",
          routerVlan:"",
      }

      this.routerForm = dbaformTmp
    },

    clkApply() {
      var newProfile = {
        routerVlan: Number(this.routerForm.routerVlan),
        routerPort: this.routerForm.routerPort,
        operate: 1,
      }

      if(this.routerForm.routerVlan == "" || this.routerForm.routerPort == "")
      {
          this.showAlertBox(
              "warn",
              "Message",
              "router port or router vlan can not be empty"
          )
          return
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      for (let i = 0; i < this.routerTable.length; i++) {
        if (this.routerTable[i].routerPort == this.routerForm.routerPort &&
            this.routerTable[i].routerVlan == this.routerForm.routerVlan
            ) {
         
              this.showAlertBox(
              "warn",
              "Message",
              "router port and router vlan have been exist"
            )
            return
        }
      }

      post("igmpRouterStatic", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadRouterStaticInfo()
     
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        routerVlan: "",
        routerPort: "",
        operate: 2,
      }

      for (i = 0; i < this.routerTable.length; i++) {
        if (this.routerTable[i].selected) {
          newProfile.routerVlan = Number(this.routerTable[i].routerVlan)
          newProfile.routerPort = this.routerTable[i].routerPort
          del.push(post("igmpRouterStatic", newProfile))
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
                this.loadRouterStaticInfo()
                this.showAlertBox("info", "Info", "Delete successful!")
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
            }
          })
            
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.routerTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.routerTable[i], "selected", true)
        } else {
          this.$set(this.routerTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if(value == 2 || value == 0)
      {
        if(this.routerForm.routerVlan != "")
        {
            let oldVlan = Number(this.routerForm.routerVlan)
            if(!isNaN(oldVlan))
            {
                if(oldVlan < 1 || oldVlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }
      
      return null
    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
